
import { Component, namespace, Prop, Vue } from 'nuxt-property-decorator'
import { OnBeforeDestroy, OnMounted } from '~/core/vue.types'
import AppLangSwitcher from '~/components/snippets/AppLangSwitcher.vue'
import { GettersType as partnerGettersType, namespace as partnerStore, Partner } from '~/store/modules/Partner'
import { getExternalIndexHref } from '~/utils/external-links.utils'

const PartnerStore = namespace(partnerStore)

@Component({
  components: {
    AppLangSwitcher,
  },
})
export default class PartnerHeader
  extends Vue
  implements OnMounted, OnBeforeDestroy {
  @Prop({ required: false, default: 'common' }) readonly type!: string
  @Prop({ required: true, default: true }) readonly isShadow!: boolean

  @PartnerStore.Getter(partnerGettersType.GET_CURRENT_PARTNER)
  private partner!: Partner

  private isMobileNavActive = false
  private isShadowAppliedByScroll = false

  get externalIndexHref (): string {
    return getExternalIndexHref(this.$config.BASE_URL, this.localePath)
  }

  toggleMobileNav () {
    this.isMobileNavActive = !this.isMobileNavActive
  }

  onScrollHandler () {
    this.isShadowAppliedByScroll = window.scrollY > 50
  }

  mounted () {
    window.addEventListener('scroll', this.onScrollHandler.bind(this), {
      passive: true,
    })
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onScrollHandler.bind(this))
  }
}
